import React, { useEffect, } from "react";
import { Button, Image } from '@bfe/moly';
import { useI18n } from '@spot-fe/base-ui'
import { sensorsClick, sensorsExposure } from '@spot-fe/utils';
import { h5Jump } from '@spot-fe/app-bridge';
import { getUrlQuery } from '@/utils/url';
import styles from './index.module.scss';
import "./reset.scss";

export default function H5Landing() {
  const { t } = useI18n();

  function handleSignUpNow() {
    sensorsClick({
      page_name: 'tokenSpalshH5Home',
      button_name: 'tokenSpalshH5JoinNows',
    })
    const code = getUrlQuery('code')
    if (code) {
      h5Jump(`by-mini://token_splash/detail?projectCode=${code}`)
    } else {
      h5Jump(`by-mini://token_splash/home`)
    }
  }

  useEffect(() => {
    sensorsExposure({
      page_name: 'fixedloan_h5_home',
    })
  }, [])

  const cardList = [
    {
      title: t('zeroBarriers'),
      subTitle: t('signUpEarlyAccess'),
      icon: <Image className={styles.imgs} src='/bycsi-root/common-static/images/92d8c966e77b494395ffde769646fa08_e26b054f2145cf71335f44d93b60e253.png' />
    },
    {
      title: t('doubleRewardStrategies'),
      subTitle: t('depositTokensOrTradeToWin'),
      icon: <Image className={styles.imgs} src='/bycsi-root/common-static/images/e0f5c4bbce1040b8826be4bbf7f82b9c_7d2cf1029bffd5413a2cb2e6a2ed6be7.png' />
    },
    {

      title: t('tradeAndEarn'),
      subTitle: t('unlockPrizePool'),
      icon: <Image className={styles.imgs} src='/bycsi-root/common-static/images/e2439ce4fd7345b8b1c810424a2cdafa_2dfca2744390cbff50c967461c4e4189.png' />,
    },
    {
      title: t('rewardsAutoCredited'),
      subTitle: t('rewardsCreditTime'),
      icon: <Image className={styles.imgs} src='/bycsi-root/common-static/images/a475cd0713754a1cbc01c091aa6825ea_396560490121761a2b75ca08699c3385.png' />,
    },
  ]

  return (
    <div className={styles.h5landing}>
      <div className={styles.topBanner}>
        <div className={styles.title}>
          <span className={styles.titleText}>
            {t('Token Splash')}
          </span>
        </div>
        <div className={styles.content}>{t('newTokenSeason')}</div>
      </div>
      <div className={styles.mainTitle}>

      </div>
      <p className={styles.forStakingHighApy}>{t('howToEarn')}</p>
      <div className={styles.cols}>
        {cardList.map((item, index) => {
          return (
            <div className={styles.card} key={index}>
              <div className={styles.title}>
                <p>
                  {item.title}
                </p>
                <p>
                  {item.subTitle}
                </p>
              </div>
              <div className={styles.icon}>
                {item.icon}
              </div>
            </div>
          )
        })}
      </div>
      <div className={styles.bottomButton}>
        <Button block variant="primary" size={"large"} data-sensors-click onClick={handleSignUpNow}>
          {t('joinNows')}
        </Button>
      </div>
    </div>
  )
}
